//console.log("new api instance");
import Api from "./api";

const ApiDataService = {
  install(Vue, options) {
    new Api(Vue, options);
  },
};
export default ApiDataService;